import { useState, useContext } from 'react'
import { t } from 'i18next'
import { Context } from '../../../../index'
import responseNotify from '../../../../hooks/responseNotify'

const Promocodes = () => {
    const {store} = useContext(Context)
    const [promoInput,setPromoInput] = useState('')
    const activatePromocode = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const response = await store.profilePromocode(promoInput)
        responseNotify({response, success: ['profile.promocode.status.success']})
        setPromoInput('')
    }

    return (
        <form className="xbox__div-2 promocode__information" onSubmit={e => activatePromocode(e)}>
            <div className="input-1 input_promoCode">
                <svg className='input-before-svg svg-fill' fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fillRule="evenodd" clipRule="evenodd" d="M13.56 3.127 5.635 9.982l1.076 1.244a.553.553 0 1 1-.83.733l-1.083-1.252-1.512 1.307a1.697 1.697 0 0 0-.178 2.394l5.732 6.626a1.697 1.697 0 0 0 2.394.168l1.51-1.306-1.076-1.244a.553.553 0 1 1 .83-.733l1.085 1.254 7.943-6.871c.71-.615.79-1.686.178-2.394l-5.581-6.451c-.666-.77-1.518-1.234-2.563-.33Zm-2.506 13.12a.554.554 0 0 1-.839.726l-.723-.836a.554.554 0 0 1 .84-.726l.722.836ZM8.887 13.74a.554.554 0 0 1-.84.726l-.722-.835a.554.554 0 0 1 .84-.726l.722.835Zm.954-2.286a1.662 1.662 0 0 1 .175-2.343 1.662 1.662 0 0 1 2.343.165c.598.691.52 1.741-.175 2.342-.694.601-1.745.527-2.343-.164Zm4.497 2.858a.55.55 0 0 1-.912-.457l.492-6.622a.556.556 0 0 1 .593-.513.55.55 0 0 1 .51.59l-.493 6.624a.554.554 0 0 1-.19.378Zm4.092-2.255c-.695.6-1.745.527-2.343-.165a1.662 1.662 0 0 1 .174-2.342 1.662 1.662 0 0 1 2.344.164 1.664 1.664 0 0 1-.175 2.343Zm-7.692-2.11a.554.554 0 0 0-.058.78.554.554 0 0 0 .84-.725.554.554 0 0 0-.782-.055Zm6.188 1.219a.554.554 0 0 1 .84-.726.554.554 0 0 1-.84.726Z" fill="#5C5C68"/></svg>
                <input id="input_promocode" type="text" placeholder={t('profile.promo.placeholder')} maxLength={16} autoComplete="off" value={promoInput} onChange={e => setPromoInput(e.target.value)} />
            </div>
            <button className="button-2 blue" disabled={promoInput ? false:true} type='submit'>
                {t('profile.promo.apply')}
            </button>
        </form>
    )
}

export default Promocodes;